var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 122,
    viewBox: "0 0 125 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 121.478C97.0178 121.478 125 94.2841 125 60.7389C125 27.1937 97.0178 0 62.5 0C27.9822 0 0 27.1937 0 60.7389C0 94.2841 27.9822 121.478 62.5 121.478Z",
    fill: "#EDEBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.507 36.0911H50.8572C48.4799 36.0911 46.5527 37.9639 46.5527 40.2742V40.2742C46.5527 42.5845 48.4799 44.4573 50.8572 44.4573H82.507C84.8843 44.4573 86.8115 42.5845 86.8115 40.2742C86.8115 37.9639 84.8843 36.0911 82.507 36.0911Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4114 52.8235H102.953C105.331 52.8235 107.258 54.6963 107.258 57.0066C107.258 59.3169 105.331 61.1898 102.953 61.1898H30.4114C28.0341 61.1898 26.1069 59.3169 26.1069 57.0066C26.1069 54.6963 28.0341 52.8235 30.4114 52.8235Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4114 69.5562H102.953C105.331 69.5562 107.258 71.429 107.258 73.7393C107.258 76.0496 105.331 77.9224 102.953 77.9224H30.4114C28.0341 77.9224 26.1069 76.0496 26.1069 73.7393C26.1069 71.429 28.0341 69.5562 30.4114 69.5562Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1803 59.793C40.1308 59.7946 40.0811 59.7956 40.0315 59.7969C40.0103 59.8505 39.9874 59.9037 39.9609 59.9558L40.1803 59.793V59.793Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.253 64.5303C113.479 38.395 93.482 15.4546 66.5889 13.2916C39.6958 11.1285 16.0903 30.5619 13.8645 56.6973C11.6388 82.8326 31.6356 105.773 58.5288 107.936C85.4219 110.099 109.027 90.6657 111.253 64.5303Z",
    fill: "#6C63FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4587 46.0938L57.8128 74.7396L44.792 61.7187",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.6c334b59b2a66202f5e6e9d7bc598915.svg";
export { ForwardRef as ReactComponent };